import { render } from "./CategoryBullets.vue?vue&type=template&id=5e9c75d6"
import script from "./CategoryBullets.vue?vue&type=script&lang=js"
export * from "./CategoryBullets.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_719f45e5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__